import { render, staticRenderFns } from "./notificaciones-form.vue?vue&type=template&id=49313d56&scoped=true"
import script from "./notificaciones-form.vue?vue&type=script&lang=js"
export * from "./notificaciones-form.vue?vue&type=script&lang=js"
import style0 from "./notificaciones-form.vue?vue&type=style&index=0&id=49313d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49313d56",
  null
  
)

export default component.exports